const START = 'GET_START';
const START_SUCCESS = `${START}/SUCCESS`;
const START_FAILURE = `${START}/FAILURE`;

const SESSION = 'GET_SESSION';
const SESSION_SUCCESS = `${SESSION}/SUCCESS`;
const SESSION_FAILURE = `${SESSION}/FAILURE`;

export default {
  START,
  START_SUCCESS,
  START_FAILURE,

  SESSION,
  SESSION_SUCCESS,
  SESSION_FAILURE
};
